<template>
  <div class="row">
    <Aguarde :show="httpSend"></Aguarde>
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <form-wizard ref="tabNota"
                       next-button-text="Próximo"
                       back-button-text="Anterior"
                       color="#556ee6">
            <tab-content :before-change="validaTabTomador" title="Tomador" icon="bx bx-user">
              <div class="row">
                <div class="col-12">
                  <button type="button" title="Copiar dados de uma nota anterior" @click="openModalCopiar()"
                          class="btn btn-label btn-sm mb-2 btn-outline-primary"><i
                      class="bx bx-copy label-icon"></i> Copiar dados de uma nota anterior
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <b-form>
                    <div class="row">
                      <h5 class="mb-3">Dados do Tomador</h5>
                    </div>
                    <div class="row">
                      <div class="col-xl-3 col-sm-4">
                        <label class="card-radio-label mb-3">
                          <input
                              type="radio"
                              @change="alter_pais()"
                              v-bind:disabled="substituicao"
                              v-model="pais_tomador.pais"
                              name="pais-tomador-brasil"
                              id="pais-tomadorbrasil"
                              class="card-radio-input"
                              value="BR"
                          />
                          <div class="card-radio">
                            <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAADgCAMAAABFJU/CAAAAq1BMVEX+3wA0qS3t2Abx9/UJnjgbojP43AEAJ3YAmzr///86sWYuSGDj1wbi7+vO0goPM35htSR2vB++zg16fz1FWVV2i7Vfd6k9WpfY3uqX1q4gQYeNnsFLZp6vpSR/zZzA5s7b0wkVNmyWlDGhr8zI0OGYxBeuyRJPsCfTwBgOoEW2wdgvTo+EvhxjbkdFrSqOwRmjxhUfp1HBsx2v4MHP7NpfwINPundvx4/AwItlPu1+AAAL2UlEQVR42u2db3eiOBSHqamGX2yWbRUFUajFzohud8f6b77/J9sX1Y6dKgmQQJzmvm7PweeE5Mm9N8FxbVQKxyKwAC1AC9ACtGEBWoAWoAVowwK0AC1AC9CGBWgBWoAWoA0L0AK0AC1AGxagBWgBWoA2LMAvC/D+3gKsEDd/Oc5fNxZgybj9p+M4jtP559YCLDX8Hp1DPN5YgMWH37NzEs+3FmCx+H7nfIi77xZggWh/cz7Ft7YFKBt/t5wz0frbApQbfg/OhXhoW4DixeO+41yMzv2tBShW57wwTqvNAvjRXc6HYUZjFMDf3eV8mGU0BgE85y7nwySjMQfgeXc5HwYZjSkAL7uL4UZjBsBcdzHbaIwAKHIXk43GAIC3/zkl479bC9B1/71zSsfdv18eYPuHUyl+tL82wCLuYqbRNAqwqLuYaDQNAizhLpeM5ksCLOcuxhlNUwDLu8v5QdhY6bMhgFXcxSyjaQRgVXcxyWiaAFjdXQwymvoByrhLaz7pvfS73emU0um02+2/9CbzlpFGUztAobt0Jr0uPRvd3mvHOKOpGaDIXeZPfZob/ae5WUZTK8BDu9XFF1dE78iwZZDR1AnwV7tVeXoyDGtt5qoPYH7JctKlhaI/MaT0WRvAvJJl56kgPkop7U46JpQ+awKYW7J8LYGPUkq7rwaUPusBmKfOrRdaOl5ajWt1HQBz3eV1SivE9LVprdYPMNddOj1aMXoNN3NpB5jrLo99Wjn6j40ajWaA+e7yNKUKYtqo0egFmN9u1aOKotdgM5dOgIJ2K2X8BAT1Go1GgIK03wtVGC+NJQq1ARSl/ZTyExHUaDSaAApLlj2qOHoNNXPpASgsWT5R5fHUTOlTB0BxyXJCNcSkkWYuDQDFJctXqiVemyh9KgcoUbJ8nOoBOBUXm9WXPlUDlClZdqmm6DdQ+lQLUKrdqke1Ra/+Zi6VAOXarV6pxniVeAC1RqMQoFy7VaerE2BXqmNOpdEoAyjbbtWjWqMn9xTqjEYVQNl2q0e9/Oj0seZmLqcudzlEXzNA0aZYudE4dbmLxi1I8XVEodE4NbmLbgU8WUfqbU+vDrBIq3gNA1BiT6y0mcupxV1OB+Bo7EdRmi4WsyDgBCDBbLZIo8gfDMbDUT37EYVGUw2goN3qk0NHiwAANkkSEiDcspAD+10ch8BmAwAkWET+eOnVMguqaOaqBPDm0SkUM6y3MQcYY9sVwML1bgewOI5DgDGELo7BZ6k/9GoYglVLnxUAtp+LPajTQpKFMQO2CYgLsATIALaNYw6wFdgBIA8TAgCYlYNY9AhAldKnU4O7HOMn4i3ANohdN9u/AVwBLAljDri78AgwZGwVH8fi7xAH1ZPTKkufTg3ucowA4RZgCeIYfAWwMNnvAJYkSQK4cRayN2ZbFm8O+La7kH+A6AVKTaZy6dPR7y7v/c8AyeJ9RhDHwA7YMxZyYMcYYwBLsuQAkK3j8AAwW++zNQCQdEwppWOCQLxUz+s7I+Hod5djrAHw/Z4DHGdjQw7jzo2Tw59sVgniGMhYSMCjEaUBj5SlFFQYjaPdXU7eYABAsIh8fzAYD4fL0cij1BuNlsPheDDw/Sh9+5sk3h7GYsyY6yZY79bbjAOY+QM61vIOlzUaR7u7vL8jfJH6Y+HrNxr76YwcByVLAAJs2RosAXhCsJAASEuehSphNEUB3j47JaPQNm409FMOYH2YCeOVywjCjGUbgESewu1cRaMpCPB7+VOW75lUabMbDdK3qXDNALYBMo5wBwCIRhomwVJGUwig/O1WOYkYb1FoKA5SDhCAcSQMiLdAsk2AdKl+EixjNI5WdT6doQ8/zeeYFUwZjAYpBwc22YawBGS13q4ALIY5/1PlNoFCRuNoVedTCzz+tADjEruzZUSAdZbtgXgNMAISYjZWaYLlEoWyACvfEPG+hvjeoFyOYLx4W1FWyWa7B+LVan0Z4aTa08qXPh2d6qy6Guf5AYCQhSsGsiIJC4FgqWY7XFarpQCquCFCUUPlMiIgIePYZlu+j4ENUq9Kbalq6dPR6y4aynGez8HBMxJm2QaJu+N8UDknWL706eh1Fz3lpEEAvj6kw5I4i8nndb2v5KElSp+OVndRDtCfDY8IQTIgXK0SsgfgKxTBQkbjaHUX5QAXOE544xkISMY3LATASTDUAVBsNI5WdzkJNU2Vw9GvFWO4AGcsAYB1xuKPi8lU2YMLjMbR6i4noaMCPAywXu0IsN+BhSCnUqjw0XONxiCAwzJzIkEIhJxt1yFwOghNAFjvKzwI/BJldS8FsAvJKgRIQt612ohXWOkiIgQ4xqycWs/AV/tVCOxWLDwux1MjFhHXva1PY4bjqKwWcoQhgN2erDaHXI8pGuMqu2pNZ1+WFwEgjGRhvMHbWqIGoAqRdhVd9qe3s3I0A7LNxn3LYPtGbeXMSiZcjAgbtnM5CHP3WHhGJROaTGcNl9J/ycmaA6uQsBiBWekspQnVgp5HfOmZcAEgZG81qJ+GJVQVpvRPHU7szoQUwf0GkMWAcSn9ykbTOfODAzHAYaH9yTLAjrEtAL3u0mhZ86DNmoQmRbIGEBhZ1lRUWKeUjgdc3OQxLNYUePxLAFWmQK2FdWWtHUOCVOgl/NfysSCpNMExqQJQd2tHleaiD7PfTLi4Doh3sjoUKIUOCYi5zUUV2ttOJkHPo0K/8+jo5G0uspaMgpnJ7W2ltbpXOutXeCn5qVOdm2vxfZvOPtvbxXYtP5Du5FpeVYtvSaPpUuoFn1aPAQkuOY18gms5u7Im81JG80QpTdNPqwfh1QvFBDOPUjpK09GVHHMoYzR356f85aD6rBccuhM4uZ6DNiWMRl9O8LhMD4dXdNSruNHUctr1mg4bljru+mn+yp/dpDfNi1JLSMPHXYsazech6M1yNxkR53Irsbd47xy+rgPXbtUj/37umQUPkFRBfxFd6ZF/V+elE8sokt66FB2Axlw64aq59qTKaf+TtmvpJdika08KlD7nl1WuPL9x8Cv1JbmLM+ziHbfy1U9jDj4uLH/vmxkUPKJk3tVP0kbTutAkkxLxCabot9zzwjtgHBzPY09btbiLHoCSpc8L68hAnOhK34/ovE15s5RSOvhQ95xIuYuh19+5ui9gHI+9Y4Lafz+0uAwGxc4YGnwBo6TRVL9BcDk7L98StwcafgWonNHMVSWef3fsx7rcRSdAGaNRcw33OEoHxY53XcU1yFJGU+Hg3K+dn0fwIZHfq89dNAOUMJrSBCPwd2rRh2pKr0Z30Q5QbDRl2wWXwQVd/LM+RuDaz2FUH4Mio6l+gNiTHX9X+UEWcemz6lo8Ct4PaT7pKVk2DVBU+qxaIglmMhu4K/4olaj02ZmLTyBGkTCDOp3rKlkaAFD0UWFhoXMkzLP2m/3UcMOfhqy+KXnSWLI0A6Dr3uQZzbxSaqGb9/o+1PGl6+Y/j1vhA5HTp4bcpXaA+UZT9gvDeV8X/sM+0CwymnmJrpn+vDl3aQKgoJmrKMJ+o+7SCEBRM9drAYT9V6dRd2kIoKiZq/UkxbD/1HIadpemAIoThXcihgJ62tJ+pgCUaObqvPYuqGG3NxH+833dv6d2gOLSZ8dxWvNJ76Xf7U6nlE6n3W7/pTeZS9TMH9runw9Q3XVcDalz8wBV3WOhvWRpLEBF91hoL1kaDFDJPRbaS5YmA1R7M1fd7mIEQHU3c9XvLmYAVHUz10Pb/aoAVRhNI+5iDsDKRvOj7X5tgNWMpil3MQpgBaNpzF3MAljWaBp0F9MAljEabe1WVwmwuNE8tA15cFMAFruZq2l3MRCgW+Qei29t1wI8F3L3WNRXsrw6gFL3WDzfuhZgjtE8XoO7GAww32hMcReTAeYZzUPbvKc1EOAlozHIXcwGeMFovrVdC7C80ZjlLlcA8Dejeb51LcDyRvN4Y+5TGgzw2MxVc7vVHwTwLVH4143Rj2g2QNe9vzf8AU0HaHxYgBagBWgBWoA2LEAL0AK0AG1YgBagBWgB2rAALUAL0AK0YQFagBagBWjDArQALUAL0IYFqC/+B7rokXbIriHnAAAAAElFTkSuQmCC"
                                alt="user-image" height="12" class="mr-1">
                            <span>Tomador Brasileiro</span>
                          </div>
                        </label>
                      </div>
                      <div class="col-xl-3 col-sm-4">
                        <label class="card-radio-label mb-3">
                          <input
                              type="radio"
                              @change="alter_pais()"
                              v-bind:disabled="substituicao"
                              v-model="pais_tomador.pais"
                              name="pais-tomador-fora"
                              id="pais-tomadorfora"
                              class="card-radio-input"
                              value="FORA"
                          />
                          <div class="card-radio">
                            <span>Tomador Estrangeiro</span>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div v-if="pais_tomador.pais!=='BR'" class="row">
                      <div class="col-12 mt-1 mb-2">
                        <multiselect
                            id="pas_codigo"
                            v-model="tomador.pas_codigo"
                            placeholder="Selecione o país"
                            track-by="pas_codigo"
                            :custom-label="labelPais"
                            :options="paises"
                            :close-on-select="true"
                            :allowEmpty="false"
                            :option-height="104"
                            :loading="isLoading"
                            :searchable="true"
                            :internal-search="false"
                            :max-height="600"
                            :show-no-results="false"
                            @search-change="pesquisarPais"
                            :show-labels="false">
                          <template slot="option" slot-scope="props">
                            <div class="option__desc">
                              <span class="option__title">{{
                                  props.option.pas_codigo
                                }} - {{ props.option.pas_nome }}</span>
                            </div>
                          </template>
                          <span slot="noOptions">Digite para pesquisar</span>
                        </multiselect>
                      </div>
                    </div>
                    <div v-if="isEstrangeiro">
                      <div class="row">
                        <div class="col-md-4">
                          <b-form-group label="NIF" label-for="sep_nif_tomador">
                            <input class="form-control" v-model="tomador.sep_nif_tomador"
                                   maxlength="40"
                                   id="sep_nif_tomador" type="text">
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group label="Nome Completo ou Razão social" label-for="sep_razao_social_tomador">
                            <input class="form-control" v-model="tomador.sep_razao_social_tomador"
                                   maxlength="150"
                                   :class="{ 'is-invalid': pais_tomador.erro_razao_social }"
                                   id="tps_razao_social_nome" type="text">
                            <div v-if="pais_tomador.erro_razao_social" class="invalid-feedback">
                              Informe o Nome/Razão social
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group label="E-mail" label-for="sep_email_tomador">
                            <input v-model="tomador.sep_email_tomador"
                                   class="form-control"
                                   maxlength="80"
                                   id="sep_email_tomador" type="email">
                          </b-form-group>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="row">
                            <h5 class="mb-3">Endereço do Tomador</h5>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <b-form-group
                              id="endexterior-group"
                              label="Endereço completo do Tomador no exterior"
                              label-for="sep_endereco_tomador">
                            <input
                                id="endexterior"
                                ref="sep_endereco_tomador"
                                v-model="tomador.sep_endereco_tomador"
                                type="text"
                                maxlength="255"
                                class="form-control"
                                placeholder=" "
                                :class="{'is-invalid': pais_tomador.erro_endereco}">
                            <div v-show="pais_tomador.erro_endereco" class="invalid-feedback">
                             Informe o endereço. Máximo de 255 caracteres
                            </div>
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="row">
                        <div class="col-md-4">
                          <b-form-group label="CPF ou CNPJ" label-for="sep_cpf_cnpj_tomador">
                            <the-mask class="form-control"
                                      :class="{ 'is-invalid': $v.tomador.sep_cpf_cnpj_tomador.$error || cpfCnpjInvalid || tomadorIsPrestador}"
                                      v-model="tomador.sep_cpf_cnpj_tomador"
                                      :disabled="substituicao"
                                      v-on:focusout.native="locTomador(tomador.sep_cpf_cnpj_tomador)"
                                      :mask="['###.###.###-##', '##.###.###/####-##']"/>
                            <div v-if=" $v.tomador.sep_cpf_cnpj_tomador.$error" class="invalid-feedback">
                              Informe o CPF ou CNPJ
                            </div>
                            <div v-show="cpfCnpjInvalid" class="invalid-feedback">
                              CPF ou CNPJ Inválido
                            </div>
                            <div v-show="tomadorIsPrestador" class="invalid-feedback">
                              CPF ou CNPJ do tomador não pode ser idêntico ao do Prestador
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-md-5">
                          <b-form-group label="Nome Completo ou Razão social" label-for="sep_razao_social_tomador">
                            <input class="form-control" v-model="tomador.sep_razao_social_tomador"
                                   maxlength="150"
                                   :class="{ 'is-invalid': $v.tomador.sep_razao_social_tomador.$error }"
                                   id="tps_razao_social_nome" type="text">
                            <div v-if="$v.tomador.sep_razao_social_tomador.$error" class="invalid-feedback">
                              Informe o Nome/Razão social
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-md-3">
                          <b-form-group label="Telefone" label-for="sep_telefone_tomador">
                            <the-mask class="form-control"
                                      v-model="tomador.sep_telefone_tomador"
                                      :mask="['(##) ##### ####', '(##) #### ####']"/>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <b-form-group label="E-mail" label-for="sep_email_tomador">
                            <input v-model="tomador.sep_email_tomador"
                                   class="form-control"
                                   maxlength="80"
                                   id="sep_email_tomador" type="email">
                          </b-form-group>
                        </div>
                        <div class="col-md-3">
                          <b-form-group label="Inscrição municipal" label-for="sep_inscricao_municipal_tomador">
                            <input class="form-control"
                                   maxlength="15"
                                   v-bind:disabled="tomador.eco_inscricaomunicipal"
                                   v-model="tomador.sep_inscricao_municipal_tomador"
                                   id="sep_inscricao_municipal_tomador"
                                   type="text">
                          </b-form-group>
                        </div>
                        <div class="col-md-3">
                          <b-form-group label="Inscrição estadual" label-for="sep_inscricao_estadual_tomador">
                            <input class="form-control"
                                   maxlength="15"
                                   v-model="tomador.sep_inscricao_estadual_tomador"
                                   id="sep_inscricao_estadual_tomador"
                                   type="text">
                          </b-form-group>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="row">
                            <h5 class="mb-3">Endereço do Tomador</h5>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3">
                          <b-form-group
                              id="cep-group"
                              label="CEP"
                              label-for="cep-reply">
                            <input
                                id="cep-reply"
                                ref="sep_cep_tomador"
                                v-model="tomador.sep_cep_tomador"
                                v-on:focusout="locCEP(tomador.sep_cep_tomador)"
                                autocomplete="no"
                                v-mask="'##.###-###'"
                                type="text"
                                maxlength="20"
                                class="form-control"
                                placeholder=" "
                                :class="{'is-invalid': errorCep || (submitted && $v.tomador.sep_cep_tomador.$error)}">
                            <div v-show="$v.tomador.sep_cep_tomador.$error" class="invalid-feedback">
                              Informe o CEP do tomador
                            </div>
                            <div v-show="errorCep" class="invalid-feedback">
                              CEP não encontrado
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-md-6">
                          <b-form-group
                              id="cidade-group"
                              label="Cidade - UF"
                              label-for="cidade">
                            <h5 v-if="tomador.sep_municipio_tomador" class="mb-3 mt-3">{{ tomador.mun_nome }} -
                              {{ tomador.mun_uf }}</h5>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-5">
                          <b-form-group
                              id="quadra-group"
                              label="Endereço/Quadra"
                              label-for="sep_endereco_tomador">
                            <input
                                id="quadra"
                                ref="sep_endereco_tomador"
                                v-model="tomador.sep_endereco_tomador"
                                type="text"
                                maxlength="255"
                                class="form-control"
                                placeholder=" "
                                :class="{'is-invalid': submitted && $v.tomador.sep_endereco_tomador.$error,}">
                            <div v-show="$v.tomador.sep_endereco_tomador.$error" class="invalid-feedback">
                              Informe o endereço. Máximo de 255 caracteres
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-md-3">
                          <b-form-group
                              id="lote-group"
                              label="Número/Lote"
                              label-for="sep_numero_endereco_tomador">
                            <input
                                id="sep_numero_endereco_tomador"
                                ref="sep_numero_endereco_tomador"
                                v-model="tomador.sep_numero_endereco_tomador"
                                type="text"
                                maxlength="10"
                                class="form-control"
                                placeholder=" "
                                :class="{'is-invalid': submitted && $v.tomador.sep_numero_endereco_tomador.$error,}">
                            <div v-show="$v.tomador.sep_numero_endereco_tomador.$error" class="invalid-feedback">
                              Informe o número. Máximo de 10 caracteres
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group
                              id="bairro-group"
                              label="Bairro"
                              label-for="sep_bairro_tomador">
                            <input
                                id="sep_bairro_tomador"
                                v-model="tomador.sep_bairro_tomador"
                                type="text"
                                maxlength="60"
                                class="form-control"
                                placeholder=" "
                                :class="{'is-invalid': submitted && $v.tomador.sep_bairro_tomador.$error,}">
                            <div v-show="$v.tomador.sep_bairro_tomador.$error" class="invalid-feedback">
                              Informe o bairro. Máximo de 60 caracteres
                            </div>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <b-form-group
                              id="complemento-group"
                              label="Complemento"
                              label-for="complemento">
                            <input
                                id="complemento"
                                v-model="tomador.sep_complemento_endereco_tomador"
                                type="text"
                                maxlength="60"
                                class="form-control"
                                :class="{'is-invalid': submitted && $v.tomador.sep_complemento_endereco_tomador.$error,}"
                                placeholder=" ">
                            <div v-show="$v.tomador.sep_complemento_endereco_tomador.$error" class="invalid-feedback">
                              Complemento deve ter no máximo 60 caracteres
                            </div>
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                  </b-form>
                </div>
              </div>
            </tab-content>
            <tab-content :before-change="validaTabServico" :lazy="true" title="Serviços" icon="bx bx-wrench">
              <div class="row">
                <div class="col-12">
                  <b-form>
                    <div class="row">
                      <h5 class="mb-3">Mês e ano da prestação do serviço (Fato Gerador do Imposto)</h5>
                    </div>
                    <div v-show="substituicao && !this.entidade.par_permite_troca_competencia" class="row">
                      <b-alert show variant="warning">
                        <i class="mdi mdi-alert-outline mr-2"></i>Não é permitida a troca de competência na substituição
                        da nota fiscal.
                      </b-alert>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <b-form-group label="Mês" label-for="mes_competencia">
                          <select id="mes_competencia"
                                  :disabled="substituicao && !this.entidade.par_permite_troca_competencia"
                                  v-model="competencia.mes"
                                  class="custom-select"
                                  :class="{'is-invalid': $v.competencia.mes.$error }"
                                  type="text">
                            <option v-for="m in meses" :key="m.codigo" v-bind:value="m.codigo">{{
                                m.descricao
                              }}
                            </option>
                          </select>
                          <div v-if=" $v.competencia.mes.$error" class="invalid-feedback">
                            Informe o mês
                          </div>
                        </b-form-group>
                      </div>
                      <div class="col-md-3">
                        <b-form-group label="Ano" label-for="ano_competencia">
                          <input class="form-control"
                                 :disabled="substituicao && !this.entidade.par_permite_troca_competencia"
                                 @change="alter_ano()"
                                 v-model="competencia.ano"
                                 v-mask="'####'"
                                 :class="{'is-invalid': $v.competencia.ano.$error }"
                                 id="ano_competencia" type="text">
                          <div v-if=" $v.competencia.ano.$error" class="invalid-feedback">
                            Informe o ano
                          </div>
                        </b-form-group>
                      </div>
                      <div class="col-md-3">
                        <b-form-group label="Competência" label-for="competencia">
                          <input class="form-control" v-model="sep_competencia"
                                 v-bind:disabled="true"
                                 id="competencia" type="text">
                        </b-form-group>
                      </div>
                    </div>
                  </b-form>
                </div>
              </div>
              <div class="row">
                <h5 class="mb-3">Informação sobre o serviço</h5>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <b-form-group label="Município onde o serviço foi prestado" label-for="sep_municipio_prestacao">
                    <multiselect
                        id="sep_municipio_prestacao"
                        v-model="servico.sep_municipio_prestacao"
                        placeholder="Selecione município"
                        track-by="mun_codigo"
                        :custom-label="labelMunicipio"
                        :class="{'is-invalid': !servico.sep_municipio_prestacao.mun_codigo}"
                        :options="municipios"
                        :close-on-select="true"
                        :option-height="104"
                        :loading="isLoading"
                        :searchable="true"
                        :internal-search="false"
                        :allowEmpty="false"
                        :max-height="600"
                        :show-no-results="false"
                        @search-change="pesquisarMunicipio"
                        :show-labels="false">
                      <template slot="option" slot-scope="props">
                        <div class="option__desc">
                          <span class="option__title">{{ props.option.mun_nome }} - {{ props.option.mun_uf }}</span>
                        </div>
                      </template>
                      <span slot="noOptions">Digite para pesquisar</span>
                    </multiselect>
                    <h6 v-show="!servico.sep_municipio_prestacao.mun_codigo" class="invalid-feedback">
                      Informe o município</h6>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <b-form-group label="Atividade desenvolvida" label-for="ser_codigo">
                    <multiselect
                        id="ser_codigo"
                        v-model="servico.ser_codigo"
                        placeholder="Selecione a atividade"
                        :class="{'is-invalid': $v.servico.ser_codigo.$error}"
                        track-by="ser_codigo"
                        :allowEmpty="false"
                        :options="list_atividades"
                        @select="selctAtividade"
                        :custom-label="customLabelAtividade"
                        :max-height="600"
                        :show-labels="false">
                      <template slot="option" slot-scope="props">
                        <div class="option__desc">
                              <span class="option__title">{{ props.option.ser_codigo }} - {{
                                  props.option.ser_descricao
                                }}</span>
                        </div>
                      </template>
                      <template slot="noOptions">Empresa não possui atividade cadastrada. Entre em contato com a
                        Prefeitura
                      </template>
                    </multiselect>
                    <h6 v-show="$v.servico.ser_codigo.$error" class="invalid-feedback">
                      Selecione a atividade desenvolvida</h6>
                  </b-form-group>
                </div>
              </div>
              <div v-if="list_cnae && list_cnae.length > 0" class="row">
                <div class="col-md-12">
                  <b-form-group label="Cnae" label-for="cnae_codigo">
                    <multiselect
                        id="cnae_codigo"
                        v-model="cnae_aux"
                        placeholder="Selecione o cnae"
                        track-by="cnae_codigo"
                        :allowEmpty="false"
                        :options="list_cnae"
                        :custom-label="customLabelCnae"
                        :max-height="600"
                        :show-labels="false">
                      <template slot="option" slot-scope="props">
                        <div class="option__desc">
                              <span class="option__title">{{
                                  props.option.cnae_codigo
                                }} - {{ props.option.cnae_nome }}</span>
                        </div>
                      </template>
                    </multiselect>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <h5 class="mb-3">Informação sobre tributação do ISS</h5>
              </div>
              <div v-show="!isAvulso" class="row">
                <div class="col-sm-12 col-md-4">
                  <b-form-group label="Exigibilidade do ISS" label-for="sep_exigibilidade_iss">
                    <select id="sep_exigibilidade_iss"
                            v-bind:disabled="true"
                            v-model="servico.sep_exigibilidade_iss"
                            class="custom-select" type="text">
                      <option value="1">Exigível</option>
                      <option value="2">Não incidência</option>
                      <option value="3">Isenção</option>
                      <option value="5">Imune</option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-sm-12 col-md-4">
                  <b-form-group label="Tributação do ISS" label-for="sep_tributacao_iss">
                    <select id="sep_tributacao_iss"
                            v-bind:disabled="verificaTributacao.disableTributacao"
                            v-model="servico.sep_tributacao_iss"
                            @change="selctTributacao(servico.sep_tributacao_iss)"
                            class="custom-select" type="text">
                      <option value="1">No Município</option>
                      <option v-if="!verificaTributacao.disableForaMunicipio" value="2">Tributada fora do
                        Município
                      </option>
                    </select>
                  </b-form-group>
                </div>
              </div>
              <div v-show="!isAvulso" class="row">
                <div class="col-md-12">
                  <b-form-group label="Município onde é tributado o ISS" label-for="sep_municipio_incidencia">
                    <multiselect
                        v-if="servico.sep_tributacao_iss !== '1'"
                        id="sep_municipio_incidencia"
                        v-model="servico.sep_municipio_incidencia"
                        placeholder="Selecione município"
                        :class="{'is-invalid': !servico.sep_municipio_incidencia.mun_codigo}"
                        track-by="mun_codigo"
                        :custom-label="labelMunicipio"
                        :options="municipios"
                        :close-on-select="true"
                        :allowEmpty="false"
                        :option-height="104"
                        :loading="isLoading"
                        :searchable="true"
                        :internal-search="false"
                        :max-height="600"
                        :show-no-results="false"
                        @search-change="pesquisarMunicipio"
                        :show-labels="false">
                      <template slot="option" slot-scope="props">
                        <div class="option__desc">
                                    <span class="option__title">{{ props.option.mun_nome }} - {{
                                        props.option.mun_uf
                                      }}</span>
                        </div>
                      </template>
                      <span slot="noOptions">Digite para pesquisar</span>
                    </multiselect>
                    <h4 class="mt-3" v-else>{{ servico.sep_municipio_incidencia.mun_nome }} -
                      {{ servico.sep_municipio_incidencia.mun_uf }} </h4>
                    <h6 v-show="!servico.sep_municipio_incidencia.mun_codigo" class="invalid-feedback">
                      Informe o município</h6>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button type="button" title="Histórico de Descrições" @click="openModalHistoricoDescricoes()"
                          class="btn btn-label btn-sm mr-2 mb-2 btn-outline-primary"><i
                      class="bx bx-star label-icon"></i> Descrições Favoritas
                  </button>
                  <b-form-group label="Descrição dos serviço" label-for="sep_discriminacao">
                        <textarea
                            v-model="servico.sep_discriminacao"
                            class="form-control"
                            :class="{'is-invalid': $v.servico.sep_discriminacao.$error }"
                            :maxlength="2000"
                            rows="15"
                            placeholder="Descrição do serviço máximo de 2000 caracteres"
                        ></textarea>
                    <div class="text-center">
                      <p v-if="servico.sep_discriminacao" class="badge position-absolute"
                         :class="{ 'badge-success': servico.sep_discriminacao.length !== 2000,
                            'badge-danger': servico.sep_discriminacao.length === 2000 }">
                        {{ servico.sep_discriminacao.length }} / 2000
                      </p>
                    </div>
                    <h6 v-show="$v.servico.sep_discriminacao.$error" class="invalid-feedback">
                      Informe a descrição do serviço realizado</h6>
                  </b-form-group>
                  <div class="form-group">
                    <div class="custom-control custom-checkbox mt-2">
                      <input id="check-save-descricao-favorito" v-bind:disabled="httpSendSalvaFavorito"
                             @change="saveDescricaoFavorito()" v-model="descricaoFavorito"
                             type="checkbox"
                             class="custom-control-input">
                      <label for="check-save-descricao-favorito" class="custom-control-label text-dark">
                        <span v-show="!descricaoFavoritaDados.dsf_codigo">Adicionar descrição aos favoritos </span>
                        <span v-show="descricaoFavoritaDados.dsf_codigo">Remover dos favoritos </span>
                        <span v-show="httpSendSalvaFavorito">
                          <i class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </tab-content>
            <tab-content :before-change="validaTabValores" :lazy="true" title="Valores" icon="bx bx-dollar">
              <div class="row">
                <div class="col-12">
                  <b-form>
                    <div class="row">
                      <h5 class="mb-3">Informações sobre valores</h5>
                    </div>
                    <div class="row justify-content-start">
                      <div class="col-md-4">
                        <b-form-group label="Valor do serviço" label-for="sep_valor">
                          <money class="form-control" id="sep_valor"
                                 :class="{ 'is-invalid': $v.valores.sep_valor.$error }"
                                 v-model="valores.sep_valor"
                                 v-bind="money"></money>
                          <div v-if=" $v.valores.sep_valor.$error" class="invalid-feedback">
                            Valor do serviço
                          </div>
                        </b-form-group>
                      </div>
                      <div v-if="servico.ser_codigo && servico.ser_codigo.ser_deducao" class="col-md-4">
                        <b-form-group label="Deduções" label-for="sep_deducoes">
                          <input v-show="servico.ser_codigo.ser_deducao && servico.ser_codigo.ser_deducao === 'N'"
                                 class="form-control"
                                 v-bind:disabled="true"
                                 value="R$ 0,00"/>
                          <money v-show="servico.ser_codigo.ser_deducao && servico.ser_codigo.ser_deducao === 'S'"
                                 class="form-control"
                                 id="sep_deducoes"
                                 v-model="valores.sep_deducoes"
                                 v-bind="money"></money>
                        </b-form-group>
                      </div>
                      <div v-if="verificaAliquota.isMei" class="col-md-4">
                        <b-form-group label="Alíquota ISS MEI %" label-for="sep_aliquotaMei">
                          <input class="form-control"
                                 id="sep_aliquotaMei"
                                 v-bind:disabled="true"
                                 value="0,00%"/>
                        </b-form-group>
                      </div>
                      <div v-else class="col-md-4">
                        <b-form-group label="Alíquota ISS %" label-for="sep_aliquotaDemais">

                          <money v-if="verificaAliquota.isSimples && !verificaAliquota.aliquotaZerada"
                                 class="form-control" id="sep_aliquotaDemais"
                                 :class="{'is-invalid': $v.valores.sep_aliquota.$error}"
                                 v-model="valores.sep_aliquota"
                                 v-bind="money_porcent"></money>

                          <money v-if="verificaAliquota.isDemaisEmpresas && !verificaAliquota.desabilitaAliquota"
                                 class="form-control"
                                 :class="{'is-invalid': $v.valores.sep_aliquota.$error}"
                                 v-model="valores.sep_aliquota"
                                 v-bind="money_porcent"></money>

                          <money
                              v-if="(verificaAliquota.isDemaisEmpresas && verificaAliquota.desabilitaAliquota) || verificaAliquota.aliquotaZerada"
                              class="form-control"
                              :disabled="true"
                              v-model="valores.sep_aliquota"
                              v-bind="money_porcent"></money>
                          <div v-if=" $v.valores.sep_aliquota.$error" class="invalid-feedback">
                            Aliquota entre 2,00 a 5,00
                          </div>
                        </b-form-group>
                      </div>
                    </div>

                    <div class="row justify-content-start">
                      <div class="col-md-4">
                        <b-form-group label="Desconto incondicionado" label-for="sep_desconto_incondicionado">
                          <money class="form-control" id="sep_desconto_incondicionado"
                                 v-model="valores.sep_desconto_incondicionado"
                                 v-bind="money"></money>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group label="Desconto condicionado" label-for="sep_desconto_condicionado">
                          <money class="form-control" id="sep_desconto_condicionado"
                                 v-model="valores.sep_desconto_condicionado"
                                 v-bind="money"></money>
                        </b-form-group>
                      </div>
                    </div>

                    <div class="row mb-1">
                      <div class="col-md-3">
                        <b-form-group label="ISS retido?">
                          <b-form-radio
                              @change="alterRentencao(valores.sep_iss_retido)"
                              v-bind:disabled="!verificaRenetencao.ativo"
                              v-model="valores.sep_iss_retido"
                              class="custom-radio custom-control-inline"
                              value="S">Sim
                          </b-form-radio>
                          <b-form-radio
                              @change="alterRentencao(valores.sep_iss_retido)"
                              v-bind:disabled="!verificaRenetencao.ativo"
                              v-model="valores.sep_iss_retido"
                              class="custom-control-inline"
                              value="N">Não
                          </b-form-radio>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group label="Responsável por retenção?">
                          <b-form-radio
                              v-bind:disabled="true"
                              v-model="valores.sep_responsavel_retencao"
                              class="custom-radio custom-control-inline"
                              value="1">Tomador
                          </b-form-radio>
                        </b-form-group>
                      </div>
                    </div>

                    <div v-if="isAvulso && isTomadorCNPJ">
                      <div class="border p-4 mb-3">
                        <div class="row">
                          <h5 class="mb-3">Cálculo do INSS</h5>
                        </div>
                        <div class="row justify-content-start">
                          <div class="col-md-3">
                            <b-form-group label="Base Mensal" label-for="sep_base_inss_mensal">
                              <money class="form-control" id="sep_base_inss_mensal"
                                     :disabled="true"
                                     v-model="valores.sep_base_inss_mensal"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="% Base INSS" label-for="sep_aliquota_base_inss">
                              <select id="sep_aliquota_base_inss" v-model="valores.sep_aliquota_base_inss"
                                      class="custom-select" type="text">
                                <option value="100">100,00%</option>
                                <option value="20">20,00%</option>
                              </select>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Base Acomulada" label-for="base_acumulado">
                              <input type="text" class="form-control"
                                     id="base_acumulado"
                                     disabled
                                     v-bind:value="inss_base_acumulado | formatNumeroBr"/>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="% Alíquota INSS" label-for="aliquota">
                              <money class="form-control" id="aliquota"
                                     :disabled="true"
                                     v-model="inss_avulso.aliquota"
                                     v-bind="money_porcent"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="INSS no Mês" label-for="valor_mensal">
                              <input type="text" class="form-control"
                                     id="valor_mensal"
                                     disabled
                                     v-bind:value="inss_mensal | formatNumeroBr"/>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="INSS já Retido" label-for="ja_retido">
                              <input type="text" class="form-control"
                                     id="ja_retido"
                                     disabled
                                     v-bind:value="inss_ja_retido | formatNumeroBr"/>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="INSS Externo" label-for="sep_inss_externo">
                              <money class="form-control" id="sep_inss_externo"
                                     v-model="valores.sep_inss_externo"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="INSS Nota" label-for="valor_desta">
                              <input type="text" class="form-control"
                                     disabled
                                     id="valor_desta"
                                     v-bind:value="inss_valor_desta | formatNumeroBr"/>
                            </b-form-group>
                          </div>
                        </div>
                      </div>

                      <div class="border p-4 mb-3">
                        <div class="row">
                          <h5 class="mb-3">Cálculo do IRRF</h5>
                        </div>
                        <div class="row justify-content-start">
                          <div class="col-md-3">
                            <b-form-group label="IRRF já Retido" label-for="rja_retido">
                              <money class="form-control" id="rja_retido"
                                     v-model="irrf_avulso.ja_retido"
                                     :disabled="true"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="% Base IRRF" label-for="rbase_nota_porcetagem">
                              <select id="rbase_nota_porcetagem" v-model="irrf_avulso.base_nota_porcetagem"
                                      class="custom-select" type="text">
                                <option value="100">100,00%</option>
                                <option value="60">60,00%</option>
                                <option value="40">40,00%</option>
                              </select>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Qtd. Dependentes" label-for="qt_dependente">
                              <input type="number" min="0" max="99" class="form-control" id="qt_dependente"
                                     v-model="irrf_avulso.qt_dependente"/>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Dedução Dependente" label-for="deducao_dependente">
                              <money class="form-control" id="deducao_dependente"
                                     v-model="irrf_avulso.deducao_dependente"
                                     :disabled="true"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Base Cálculo IRRF" label-for="rbase_calculo_mensal">
                              <money class="form-control" id="rbase_calculo_mensal"
                                     v-model="irrf_avulso.base_calculo_mensal"
                                     :disabled="true"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="% Alíquota IRRF" label-for="raliquota">
                              <money class="form-control" id="raliquota"
                                     v-model="irrf_avulso.aliquota"
                                     :disabled="true"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="IRRF Bruto" label-for="bruto">
                              <money class="form-control" id="bruto"
                                     v-model="irrf_avulso.bruto"
                                     :disabled="true"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Parcela Dedutiva" label-for="parc_dedutiva">
                              <money class="form-control" id="parc_dedutiva"
                                     v-model="irrf_avulso.parc_dedutiva"
                                     :disabled="true"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Valor IRRF Desta" label-for="rvalor_desta">
                              <money class="form-control" id="rvalor_desta"
                                     v-model="irrf_avulso.valor_desta"
                                     :disabled="true"
                                     v-bind="money"></money>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-2 justify-content-start">
                      <div class="col-md-3">
                        <b-form-group label="INSS" label-for="sep_inss">
                          <money class="form-control" id="sep_inss"
                                 v-model="valores.sep_inss"
                                 :disabled="isAvulso && isTomadorCNPJ"
                                 v-bind="money"></money>
                        </b-form-group>
                      </div>
                      <div class="col-md-3">
                        <b-form-group label="IR" label-for="sep_ir">
                          <money class="form-control" id="sep_ir"
                                 v-model="valores.sep_ir"
                                 :disabled="isAvulso && isTomadorCNPJ"
                                 v-bind="money"></money>
                        </b-form-group>
                      </div>
                      <div class="col-md-3">
                        <b-form-group label="PIS" label-for="sep_pis">
                          <money class="form-control" id="sep_pis"
                                 v-model="valores.sep_pis"
                                 v-bind="money"></money>
                        </b-form-group>
                      </div>
                      <div class="col-md-3">
                        <b-form-group label="CSLL" label-for="sep_csll">
                          <money class="form-control" id="sep_csll"
                                 v-model="valores.sep_csll"
                                 v-bind="money"></money>
                        </b-form-group>
                      </div>
                      <div class="col-md-3">
                        <b-form-group label="COFINS" label-for="sep_cofins">
                          <money class="form-control" id="sep_cofins"
                                 v-model="valores.sep_cofins"
                                 v-bind="money"></money>
                        </b-form-group>
                      </div>
                      <div class="col-md-3">
                        <b-form-group label="Outras" label-for="sep_outras_retencoes">
                          <money class="form-control" id="sep_outras_retencoes"
                                 v-model="valores.sep_outras_retencoes"
                                 v-bind="money"></money>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <h5 class="mb-3">Informações sobre o cálculo</h5>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="table-responsive">
                          <table class="table table-sm m-0">
                            <thead>
                            <tr>
                              <th>Descrição</th>
                              <th>Valor</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <th scope="row">Valor do Serviço</th>
                              <td>
                                    <span
                                        class="badge badge-success font-size-12">{{
                                        valores.sep_valor | formatNumeroBr
                                      }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Desconto Deduções</th>
                              <td>
                                    <span class="badge badge-danger font-size-12">{{
                                        valores.sep_deducoes | formatNumeroBr
                                      }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Desconto incondicionado</th>
                              <td>
                                    <span class="badge badge-danger font-size-12">{{
                                        valores.sep_desconto_incondicionado | formatNumeroBr
                                      }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Alíquota</th>
                              <td>
                                    <span
                                        class="badge badge-success font-size-12">{{
                                        valores.sep_aliquota + '%'
                                      }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Valor ISS</th>
                              <td>
                                <span class="badge badge-success font-size-12">{{ sep_iss | formatNumeroBr }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Desconto condicionado</th>
                              <td>
                                    <span
                                        class="badge badge-danger font-size-12">{{
                                        valores.sep_desconto_condicionado | formatNumeroBr
                                      }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Retenções federais</th>
                              <td>
                                     <span
                                         class="badge badge-danger font-size-12">{{
                                         retencao_federal | formatNumeroBr
                                       }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Valor Líquido</th>
                              <td>
                                    <span
                                        class="badge badge-success font-size-12">{{
                                        valor_liquido | formatNumeroBr
                                      }}</span>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <h6 v-show="valorISSNegativo" class="text-danger">Valor do ISS não pode ser negativo</h6>
                    <h6 v-show="valorLiquidoNegativo" class="text-danger">Valor líquido deve ser maior que R$
                      0,00</h6>
                  </b-form>
                </div>
              </div>
            </tab-content>
            <tab-content title="Emissão" :lazy="true" icon="bx bx-check-double">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <h5 class="mb-3">Resumo da Nota</h5>
                  </div>
                </div>
              </div>
              <div v-if="substituindo.not_numero" class="row">
                <div class="col-md-4">
                  <label>Nota Fiscal a ser substituída</label>
                  <p class="font-weight-bold">{{ substituindo.not_numero }}</p>
                </div>
              </div>
              <div v-if="isEstrangeiro" class="row">
                <div class="col-md-3">
                  <label>Tomador Estrangeiro</label>
                  <p v-if="tomador.pas_codigo">{{ tomador.pas_codigo.pas_codigo }} - {{
                      tomador.pas_codigo.pas_nome
                    }}</p>
                </div>
                <div class="col-md-5">
                  <label>Nome/Razão Social</label>
                  <p>{{ tomador.sep_razao_social_tomador }}</p>
                </div>
                <div class="col-md-3">
                  <label>NIF</label>
                  <p>{{ tomador.sep_nif_tomador | naoInformado }}</p>
                </div>
                <div class="col-md-4">
                  <label>E-mail</label>
                  <p>{{ tomador.sep_email_tomador | naoInformado }}</p>
                </div>
              </div>
              <div v-else class="row">
                <div class="col-md-3">
                  <label>CPF/CNPJ</label>
                  <p>{{ tomador.sep_cpf_cnpj_tomador }}</p>
                </div>
                <div class="col-md-5">
                  <label>Nome/Razão Social</label>
                  <p>{{ tomador.sep_razao_social_tomador }}</p>
                </div>
                <div class="col-md-4">
                  <label>E-mail</label>
                  <p>{{ tomador.sep_email_tomador | naoInformado }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <label>Competência</label>
                  <p>{{ competencia.mes }}/{{ competencia.ano }}</p>
                </div>
                <div class="col-md-4">
                  <label>Município onde é devido o ISS</label>
                  <p>{{ servico.sep_municipio_incidencia.mun_nome }}-{{
                      servico.sep_municipio_incidencia.mun_uf
                    }}</p>
                </div>
                <div class="col-md-5">
                  <label>Município onde o serviço foi prestado</label>
                  <p>{{ servico.sep_municipio_prestacao.mun_nome }}-{{
                      servico.sep_municipio_prestacao.mun_uf
                    }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>Atividade desenvolvida</label>
                  <p>{{ servico.ser_codigo.ser_codigo }}-{{ servico.ser_codigo.ser_descricao }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>Cnae</label>
                  <p>{{ servico.cnae_codigo.cnae_codigo }}-{{ servico.cnae_codigo.cnae_nome }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>Descrição dos serviço</label>
                  <textarea
                      v-model="servico.sep_discriminacao"
                      class="form-control"
                      :disabled="true"
                      rows="15"></textarea>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="table-responsive">
                    <table class="table table-sm m-0">
                      <thead>
                      <tr>
                        <th>Descrição</th>
                        <th>Valor</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <th scope="row">Valor do Serviço</th>
                        <td>
                                    <span
                                        class="badge badge-success font-size-12">{{
                                        valores.sep_valor | formatNumeroBr
                                      }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Desconto incondicionado</th>
                        <td>
                                    <span class="badge badge-danger font-size-12">{{
                                        valores.sep_desconto_incondicionado | formatNumeroBr
                                      }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Alíquota</th>
                        <td>
                                    <span
                                        class="badge badge-success font-size-12">{{
                                        valores.sep_aliquota + '%'
                                      }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Valor ISS</th>
                        <td>
                          <span class="badge badge-success font-size-12">{{ sep_iss | formatNumeroBr }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Desconto condicionado</th>
                        <td>
                                    <span
                                        class="badge badge-danger font-size-12">{{
                                        valores.sep_desconto_condicionado | formatNumeroBr
                                      }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Retenções federais</th>
                        <td>
                                     <span
                                         class="badge badge-danger font-size-12">{{
                                         retencao_federal | formatNumeroBr
                                       }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Valor Líquido</th>
                        <td>
                                   <span
                                       class="badge badge-success font-size-12">{{
                                       valor_liquido | formatNumeroBr
                                     }}</span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </tab-content>
            <template slot="footer" scope="props">
              <div class=wizard-footer-left>
                <wizard-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab()"
                               :style="props.fillButtonStyle"><i class="fas fa-arrow-left"></i> Anterior
                </wizard-button>
              </div>
              <div class="wizard-footer-right">
                <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right"
                               :style="props.fillButtonStyle">Próximo <i class="fas fa-arrow-right"></i>
                </wizard-button>
                <button v-if="props.isLastStep && !isAvulso" type="button"
                        @click="confirmacao(0)"
                        class="wizard-footer-right btn btn-label btn-success"><i
                    class="bx bx-check-double label-icon"></i>
                  <span v-if="substituicao">Confirmar substituição da nota</span>
                  <span v-else>Emitir nota fiscal</span>
                </button>
                <button v-else-if="props.isLastStep && isAvulso" type="button"
                        @click="confirmacaoAvulsa(0)"
                        class="wizard-footer-right btn btn-label btn-success"><i
                    class="bx bx-check-double label-icon"></i>
                  Emitir nota fiscal avulsa
                </button>
                <!--
                <button v-if="props.isLastStep" type="button"
                        @click="confirmacao(1)"
                        class="wizard-footer-right finish-button btn btn-label btn-light mr-3">
                  <i class="bx bx-save label-icon"></i>
                  Salvar nota em rascunho
                </button> -->
              </div>
            </template>
          </form-wizard>
        </div>
      </div>
    </div>
    <b-modal
        id="modal-copy-nota"
        ref="modal-copy-nota"
        size="xl"
        title="Copiar dados de uma nota fiscal"
        title-class="font-18"
        :hide-header-close="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true">
      <div class="modal-body">
        <fieldset v-if="copyNota.ultima_nota.length > 0" class="row border div-group">
          <legend class="div-group">Última nota fiscal emitida</legend>
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-nowrap table-centered mb-0">
                <tbody>
                <tr v-for="n in copyNota.ultima_nota" :key="n.not_numero">
                  <td class="border-0 border-white">
                    <h5 class="text-white font-size-12 mb-1">`</h5>
                    <p class="text-muted mb-0"><a @click="selecionaUltimaNota(n.not_hash)" href="javascript:void(0);">Selecionar</a>
                    </p>
                  </td>
                  <td class="border-0 border-white">
                    <h5 class="text-truncate font-size-12 mb-1">Data/Hora</h5>
                    <p class="text-muted mb-0">{{ n.not_emissao | formatDateHora }}</p>
                  </td>
                  <td class="border-0 border-white"><h5 class="text-truncate font-size-12 mb-1"> Número </h5>
                    <p class="text-muted mb-0">{{ n.not_numero }}</p></td>
                  <td class="border-0 border-white"><h5 class="text-truncate font-size-12 mb-1"> Tomador </h5>
                    <p class="text-muted mb-0">{{ n.sep_razao_social_tomador }}</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </fieldset>
        <loader :loading="httpSendPesquisaCopyNota">
          <fieldset class="row border div-group">
            <legend class="div-group">Pesquisar nota fiscal</legend>
            <div class="col-md-3">
              <b-form-group label="Ano" label-for="fnot_emissao_ano">
                <input
                    id="fnot_emissao_ano"
                    v-model="copyNota.filtro.not_emissao_ano"
                    v-mask="'####'"
                    type="text"
                    maxlength="4"
                    class="form-control"
                    placeholder="Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Números Finais"
                  label-for="fnot_numero">
                <input
                    id="fnot_numero"
                    v-model="copyNota.filtro.not_numero"
                    type="text"
                    maxlength="11"
                    class="form-control"
                    placeholder="Números após os zeros">
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group
                  label="´"
                  class="text-white">
                <button type="button"
                        @click="pesquisarUltimaNotas()"
                        class="mt-1 btn btn-sm btn-label btn-primary"><i
                    class="bx bx-search label-icon"></i>
                  Pesquisar
                </button>
              </b-form-group>
            </div>
            <div class="col-md-12">
              <div v-if="copyNota.resultado_pesquisa && copyNota.resultado_pesquisa.length < 1"
                   class="alert alert-warning text-dark" role="alert"><h5>Nenhuma nota fiscal encontrada</h5>
                <p>Certifique-se de que o <b>Ano</b> e <b>Números Finais</b> estejam escritas corretamente.<br>
                  Por exemplo:<br>
                  Se o número da nota fiscal for <b>202200000000276</b> <br>
                  No campo <b>Ano</b> você deve informar <b>2022</b><br>
                  No campo <b>Números Finais</b> você deve informar <b>276</b><br></p>
              </div>
              <div class="table-responsive">
                <table class="table table-nowrap table-centered mb-0">
                  <tbody>
                  <tr v-for="n in copyNota.resultado_pesquisa" :key="n.not_numero">
                    <td class="border-0 border-white">
                      <h5 class="text-white font-size-12 mb-1">`</h5>
                      <p class="text-muted mb-0"><a @click="selecionaUltimaNota(n.not_hash)" href="javascript:void(0);">Selecionar</a>
                      </p>
                    </td>
                    <td class="border-0 border-white">
                      <h5 class="text-truncate font-size-12 mb-1">Data/Hora</h5>
                      <p class="text-muted mb-0">{{ n.not_emissao | formatDateHora }}</p>
                    </td>
                    <td class="border-0 border-white"><h5 class="text-truncate font-size-12 mb-1"> Número </h5>
                      <p class="text-muted mb-0">{{ n.not_numero }}</p></td>
                    <td class="border-0 border-white"><h5 class="text-truncate font-size-12 mb-1"> Tomador </h5>
                      <p class="text-muted mb-0">{{ n.sep_razao_social_tomador }}</p>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </fieldset>
        </loader>
      </div>
      <template #modal-footer="{cancel}">
        <b-button @click="closeModalCopiar()" variant="outline-dark">
          Fechar
        </b-button>
      </template>
    </b-modal>
    <b-modal
        id="modal-historico-descricoes"
        ref="modal-historico-descricoes"
        size="xl"
        title="Descrições Favoritas"
        title-class="font-18"
        :hide-header-close="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true">
      <div class="modal-body">
        <loader :loading="httpSendPesquisaCopyNota || httpSendSalvaFavorito">
          <fieldset class="row border div-group">
            <legend class="div-group">Descrições favoritas</legend>
            <div class="col-md-12">
              <div v-if="descricaoFavoritaDados.lista && descricaoFavoritaDados.lista.length < 1"
                   class="alert alert-warning text-dark" role="alert"><h5>Sem descrições favoritas</h5>
                <p>Clique em <b>Adicionar descrição aos favoritos</b> abaixo do campo <b>Descrição dos serviço</b> para
                  adicionar descrição aos favoritos.</p>
              </div>
              <div class="table-responsive">
                <table class="table table-centered mb-0">
                  <tbody>
                  <tr v-for="f in descricaoFavoritaDados.lista" :key="f.dsf_codigo">
                    <td class="border-0 border-white">
                      <a href="javascript:void(0);" @click="selecionarDescricaoFavorito(f.dsf_descricao)">Selecionar</a>
                    </td>
                    <td class="border-0 border-white">
                      {{ f.dsf_descricao }}
                    </td>
                    <td class="border-0 border-white">
                      <a href="javascript:void(0);" @click="confirmacaoRemoverFavorito(f.dsf_codigo)"
                         class="text-danger">Remover</a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </fieldset>
        </loader>
      </div>
      <template #modal-footer="{cancel}">
        <b-button @click="closeModalHistoricoDescricoes()" variant="outline-dark">
          Fechar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {TheMask} from 'vue-the-mask'
import {VMoney, Money} from 'v-money'
import Loader from "@/components/widgets/loader";
import Aguarde from "@/components/widgets/aguarde";
import {FormWizard, TabContent, WizardButton} from "vue-form-wizard";
import {required, minValue, maxValue, minLength, maxLength} from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import {getCEP} from "@/api/externa/cep";
import {getAtividadeCnae, getBaseMensal, getTomador} from "@/api/core/pessoa";
import {autocompleteMunicipio, autocompletePaises} from "@/api/geral/autocomplete";
import moment from "moment";
import {gerarNota, getNotaFiscal, getNotaFiscalTributacaoSimples} from "@/api/nfse/nota";
import {arredondamento, isCnpj, listMeses, validaCpfCnpj, getFimMesDate, naCompetencia} from "@/helps/util";
import {gerarNotaAvulsa} from "@/api/nfse/nota_avulsa";
import {notifyErro} from "@/helps/notificacao";
import store from "@/state/store";
import {locEmpresa} from "@/api/externa/apiExt";

const {notifySucesso} = require("../../../../helps/notificacao");
const {
  getEnviaEmailNotaFiscal,
  listNotas,
  deleteDescricaoFavorita, saveDescricaoFavorita, listDescricaoFavorita
} = require("../../../../api/nfse/nota");

export default {
  name: "nota-fiscal",
  components: {
    Multiselect,
    TheMask,
    Money,
    Loader,
    Aguarde,
    FormWizard,
    TabContent,
    WizardButton,
  },
  props: {
    substituicao: {
      type: Boolean,
      default: false
    },
  },
  directives: {money: VMoney},
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2
      },
      money_porcent: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '%',
        precision: 2
      },
      httpSend: false,
      httpSendPesquisaCopyNota: false,
      httpSendSalvaFavorito: false,
      meses: [],
      list_atividades: [],
      list_cnae: [],
      isAvulso: false,
      isTomadorCNPJ: false,
      cpfCnpjInvalid: false,
      tomadorIsPrestador: false,
      descricaoFavorito: false,
      substituindo: {
        not_hash: null,
        not_numero: null
      },
      copyNota: {
        ultima_nota: [],
        filtro: {
          nota_pagina: 1,
          not_emissao_ano: moment().format('YYYY'),
          not_numero: null
        },
        resultado_pesquisa: null
      },
      pais_tomador: {
        pais: 'BR',
        erro_razao_social: false,
        erro_endereco: false
      },
      tomador: {
        sep_cpf_cnpj_tomador: '',
        sep_nif_tomador: '',
        sep_razao_social_tomador: '',
        sep_inscricao_municipal_tomador: '',
        sep_inscricao_estadual_tomador: '',
        sep_endereco_tomador: '',
        sep_numero_endereco_tomador: '',
        sep_complemento_endereco_tomador: '',
        sep_bairro_tomador: '',
        sep_municipio_tomador: '',
        sep_cep_tomador: '',
        sep_telefone_tomador: '',
        pas_codigo: '',
        eco_substituicao: '',
      },
      cnae_aux: null,
      servico: {
        sep_competencia: "",
        sep_exigibilidade_iss: "1",
        sep_tributacao_iss: "1",
        sep_municipio_incidencia: {
          mun_codigo: "",
          mun_nome: "",
          mun_uf: "",
        },
        sep_municipio_prestacao: {
          mun_codigo: "",
          mun_nome: "",
          mun_uf: "",
        },
        ser_codigo: "",
        cnae_codigo: "",
        sep_discriminacao: "",
        sep_data_tributacao:"",
      },
      valores: {
        sep_valor: 0.00,
        sep_iss: 0.00,
        sep_deducoes: 0.00,
        sep_aliquota: 0.00,
        sep_desconto_incondicionado: 0.00,
        sep_desconto_condicionado: 0.00,
        sep_iss_retido: 'N',
        sep_responsavel_retencao: null,
        sep_inss: 0.00,
        sep_ir: 0.00,
        sep_pis: 0.00,
        sep_csll: 0.00,
        sep_cofins: 0.00,
        sep_outras_retencoes: 0.00,
        sep_base_inss_mensal: 0.00,
        sep_aliquota_base_inss: 100.00,
        sep_inss_externo: 0.00
      },
      competencia: {
        mes: moment().format('M').padStart(2, '0'),
        ano: moment().format('YYYY'),
      },
      verificaAliquota: {
        isMei: false,
        isSimples: false,
        isDemaisEmpresas: false,
        desabilitaAliquota: false,
        aliquotaZerada: false,
      },
      verificaTributacao: {
        disableTributacao: false,
        disableForaMunicipio: true,
        disableImune: true
      },
      verificaRenetencao: {
        ativo: false,
        reter: false,
      },
      inss_avulso: {
        base_calculo_mensal: 0.00,
        aliquota: 11.00,
        ja_retido: 0.00,
        teto: 0.00,
      },
      irrf_avulso: {
        ja_retido: 0.00,
        base_calculo_mensal: 0.00,
        base_nota_porcetagem: 100.00,
        qt_dependente: 0,
        deducao_dependente: 0.00,
        base_acumulado: 0.00,
        aliquota: 11.00,
        bruto: 0.00,
        parc_dedutiva: 0.00,
        valor_desta: 0.00
      },
      descricaoFavoritaDados: {
        dsf_codigo: null,
        lista: []
      },
      aliquota: 0.00,
      paises: [],
      municipios: [],
      tipoEndExiste: false,
      errorCep: false,
      valorLiquidoZerado: false,
      valorISSNegativo: false,
      valorLiquidoNegativo: false,
      submitted: false,
      isLoading: false,
      desableIssRetido: false
    };
  },
  validations: {
    tomador: {
      sep_cpf_cnpj_tomador: {
        required,
      },
      sep_razao_social_tomador: {
        required,
        maxLength: maxLength(150),
      },
      sep_cep_tomador: {
        required,
      },
      sep_endereco_tomador: {
        required,
        maxLength: maxLength(255),
      },
      sep_numero_endereco_tomador: {
        required,
        maxLength: maxLength(10),
      },
      sep_bairro_tomador: {
        required,
        maxLength: maxLength(60),
      },
      sep_complemento_endereco_tomador: {
        maxLength: maxLength(60),
      },
    },
    competencia: {
      mes: {
        required
      },
      ano: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(4),
      }
    },
    servico: {
      sep_municipio_incidencia: {
        required
      },
      sep_municipio_prestacao: {
        required
      },
      ser_codigo: {
        required
      },
      sep_discriminacao: {
        required
      }
    },
    valores: {
      sep_valor: {
        required,
        minValue: minValue(0.01)
      },
      sep_aliquota: {
        required,
        minValue: minValue(2.00),
        maxValue: maxValue(5.00)
      },
    },
  },
  async created() {
    let statusEmpresa = parseInt(this.empresa.tab_107situacao);
    if (statusEmpresa !== 1003) {
      notifyErro("Impossível emitir NFS-e", "A empresa possui pendências cadastrais ou fiscais. Procurar o setor tributário ou de finanças do município")
      await this.$router.push({name: 'painel'})
    }
    let tipoEmpresa = parseInt(this.empresa.pes_tipopessoa);
    if (tipoEmpresa === 2) {
      this.isAvulso = true;
    }
    if (tipoEmpresa === 4) {
      notifyErro("Impossível emitir NFS-e", "Esta empresa não tem permissão para a utilização deste recurso")
      await this.$router.push({name: 'painel'})
    } else {
      this.httpSend = true;
      await this.atividadeCnae();
      this.httpSend = false;
    }
    if (this.entidade) {
      const mun_entidade = parseInt(this.entidade.mun_codigo);
      const mun_empresa = parseInt(this.empresa.mun_codigo);
      if (mun_empresa !== mun_entidade) {
        notifyErro("Impossível emitir NFS-e", "Empresa com endereço comercial em outro município")
        await this.$router.push({name: 'painel'})
      }
      this.municipioPadrao();
      this.servico.sep_municipio_prestacao.mun_codigo = this.entidade.mun_codigo;
      this.servico.sep_municipio_prestacao.mun_nome = this.entidade.mun_nome;
      this.servico.sep_municipio_prestacao.mun_uf = this.entidade.mun_uf;
    }
    if (this.isAvulso && this.isTomadorCNPJ) {
      this.baseMensal();
    }
    this.alter_ano();
    if (this.substituicao) {
      this.substituindo.not_hash = this.$route.params.not_hash;
      this.notaFiscal(this.$route.params.not_hash);
    }
  },
  computed: {
    entidade: {
      get: function () {
        return this.$store.state.auth.currentEntidade;
      },
    },
    empresa: {
      get: function () {
        if (this.$store.state.auth.currenEmpresa) {
          return this.$store.state.auth.currenEmpresa;
        } else {
          return {eco_tributacao: null}
        }
      },
    },
    isEstrangeiro: {
      get: function () {
        return this.pais_tomador.pais !== 'BR';
      },
    },
    sep_competencia: {
      get: function () {
        if (this.competencia.mes && this.competencia.ano) {
          return this.competencia.mes + '/' + this.competencia.ano;
        }
        return '';
      },
    },
    sep_competencia_data: {
      get: function () {
        if (this.competencia.mes && this.competencia.ano) {
          return this.competencia.ano + '-' + this.competencia.mes + '-01';
        }
        return '';
      },
    },
    sep_iss: {
      get: function () {
        return (((this.valores.sep_valor - this.valores.sep_deducoes) - this.valores.sep_desconto_incondicionado) * this.valores.sep_aliquota) / 100;
      },
    },
    retencao_federal: {
      get: function () {
        return this.valores.sep_inss + this.valores.sep_ir + this.valores.sep_pis + this.valores.sep_csll + this.valores.sep_cofins + this.valores.sep_outras_retencoes;
      },
    },
    valor_liquido: {
      get: function () {
        const iss_retido = (this.valores.sep_iss_retido === 'S') ? this.valores.sep_iss : 0.00;
        return this.valores.sep_valor - (iss_retido + this.valores.sep_desconto_incondicionado + this.valores.sep_desconto_condicionado + this.retencao_federal)
      },
    },
    inss_base_acumulado: {
      get: function () {
        return ((this.valores.sep_valor * this.valores.sep_aliquota_base_inss) / 100) + this.valores.sep_base_inss_mensal;
      },
    },
    inss_mensal: {
      get: function () {
        return (this.inss_base_acumulado * this.inss_avulso.aliquota) / 100;
      },
    },
    inss_ja_retido: {
      get: function () {
        return this.inss_avulso.ja_retido;
      },
    },
    inss_valor_desta: {
      get: function () {
        const valor = (this.inss_mensal - (this.inss_ja_retido + this.valores.sep_inss_externo));
        if (valor > 0 && this.isAvulso && this.isTomadorCNPJ) {
          return valor;
        } else {
          return 0;
        }
      },
    },
  },
  watch: {
    sep_iss: {
      handler(val) {
        this.valores.sep_iss = val;
      },
    },
    inss_valor_desta: {
      handler(val) {
        this.valores.sep_inss = val;
      },
    },
  },
  methods: {
    notaFiscal(not_hash) {
      this.httpSend = true
      getNotaFiscal(not_hash, {eco_codigo: this.empresa.eco_codigo}).then(result => {
        if (result.status) {
          this.populaNotaFiscal(result.dados)
          this.closeModalCopiar()
        } else {
          notifyErro("Erro Interno", result.mensagem)
          this.$router.push({name: 'contribuinte-nota-fiscal-lista'})
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    pesquisarUltimaNotas() {
      this.httpSendPesquisaCopyNota = true;
      listNotas(this.empresa.eco_codigo, this.copyNota.filtro).then(result => {
        if (result.status) {
          this.copyNota.resultado_pesquisa = result.dados.notas;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSendPesquisaCopyNota = false;
      })
    },
    atividadeCnae() {
      return new Promise(resolve => {
        getAtividadeCnae(this.empresa).then(result => {
          if (result.status) {
            this.copyNota.ultima_nota = result.dados.ultima_nota;
            this.list_atividades = result.dados.atividade;
            if (this.list_atividades.length < 1) {
              notifyErro("Impossível emitir NFS-e", "Empresa não possui atividade cadastrada. Entre em contato com a Prefeitura")
            }
            this.list_cnae = result.dados.cnae;
          }
          resolve(true)
        }).catch(error => {
          console.log(error)
        }).finally(() => {
          this.httpSend = false
        })
      });
    },
    locCEP(cep) {
      if (!cep) {
        return
      }
      this.httpSend = true;
      this.errorCep = false;
      getCEP(cep).then(result => {
        if (result.status === 200) {
          if (Object.prototype.hasOwnProperty.call(result.data, 'erro')) {
            this.$refs.sep_cep_tomador.focus();
            this.errorCep = true;
            this.tomador.mun_uf = '';
            this.tomador.mun_nome = '';
            this.tomador.sep_municipio_tomador = null;
            this.tomador.sep_bairro_tomador = '';
            this.tomador.sep_endereco_tomador = '';
          } else {
            this.errorCep = false;
            this.tomador.mun_uf = result.data.uf;
            this.tomador.mun_nome = result.data.localidade;
            this.tomador.sep_municipio_tomador = result.data.ibge;
            this.tomador.sep_bairro_tomador = result.data.bairro;
            this.tomador.sep_endereco_tomador = result.data.logradouro;
            if (this.tomador.sep_endereco_tomador) {
              this.$refs.sep_numero_endereco_tomador.focus();
            } else {
              this.$refs.sep_endereco_tomador.focus()
            }
          }
        }
      }).catch(error => {
        this.errorCep = true;
        this.tomador.mun_uf = '';
        this.tomador.mun_nome = '';
        this.tomador.sep_municipio_tomador = null;
        console.log(error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    locTomador(sep_cpf_cnpj_tomador) {
      if (!sep_cpf_cnpj_tomador) {
        return
      }
      if (!validaCpfCnpj(sep_cpf_cnpj_tomador)) {
        this.cpfCnpjInvalid = true;
        return
      }
      if (this.empresa.pes_cpfcnpj === sep_cpf_cnpj_tomador) {
        this.tomadorIsPrestador = true;
        return
      }
      this.cpfCnpjInvalid = false;
      this.tomadorIsPrestador = false;
      this.httpSend = true;
      getTomador({cpf_cnpj: sep_cpf_cnpj_tomador}).then(async result => {
        if (result.status) {
          this.tomador = result.dados;
          this.isTomadorCNPJ = isCnpj(this.tomador.sep_cpf_cnpj_tomador);
          if (this.tomador.sep_municipio_tomador === "" && this.isTomadorCNPJ) {
            await this.locTomadorWeb();
          }
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    async locTomadorWeb() {
      return new Promise(resolve => {
        this.httpSend = true
        locEmpresa(this.tomador.sep_cpf_cnpj_tomador).then(result => {
          if (Object.prototype.hasOwnProperty.call(result.data, 'cnpj_raiz')) {
            const empresaWeb = result.data;
            this.tomador.sep_razao_social_tomador = empresaWeb.razao_social
            this.tomador.sep_telefone_tomador = empresaWeb.estabelecimento.ddd1 + empresaWeb.estabelecimento.telefone1
            this.tomador.sep_email_tomador = empresaWeb.estabelecimento.email
            //this.tomador.ep_inscricao_municipal_estadual = empresaWeb.razao_social
            this.tomador.sep_cep_tomador = empresaWeb.estabelecimento.cep
            this.tomador.mun_nome = empresaWeb.estabelecimento.cidade.nome
            this.tomador.mun_uf = empresaWeb.estabelecimento.estado.sigla
            this.tomador.sep_endereco_tomador = empresaWeb.estabelecimento.tipo_logradouro +" "+ empresaWeb.estabelecimento.logradouro
            this.tomador.sep_numero_endereco_tomador = empresaWeb.estabelecimento.numero
            this.tomador.sep_bairro_tomador = empresaWeb.estabelecimento.bairro
            this.tomador.sep_complemento_endereco_tomador = String(empresaWeb.estabelecimento.complemento)
            this.tomador.sep_complemento_endereco_tomador = this.tomador.sep_complemento_endereco_tomador.replace(/\s{2,}/g, ' ');
            this.tomador.sep_municipio_tomador = empresaWeb.estabelecimento.cidade.ibge_id
            resolve(true);
          } else {
            resolve(false)
          }
        }).catch(error => {
          resolve(false);
          console.log(error)
        }).finally(() => {
          this.httpSend = false
        })
      })
    },
    baseMensal() {
      getBaseMensal({eco_codigo: this.empresa.eco_codigo, sep_competencia: this.sep_competencia_data}).then(result => {
        if (result.status) {
          const dados = result.dados;
          this.valores.sep_base_inss_mensal = parseFloat(dados.inss_base_anterior);
          this.inss_avulso.ja_retido = parseFloat(dados.inss_retido_anterior);
          this.inss_avulso.teto = parseFloat(dados.teto_previdencia);
          this.valores.sep_inss_externo = parseFloat(dados.inss_externo);
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    pesquisarPais(search) {
      if (search && search.length > 1) {
        this.isLoading = true;
        autocompletePaises({query: search}).then(response => {
          if (response.status) {
            if (response.dados) {
              this.paises = response.dados;
            }
          }
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.isLoading = false;
        })
      }
    },
    pesquisarMunicipio(search) {
      if (search && search.length > 1) {
        this.isLoading = true;
        autocompleteMunicipio({query: search}).then(response => {
          if (response.status) {
            if (response.dados) {
              this.municipios = response.dados;
            }
          }
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.isLoading = false;
        })
      }
    },
    async verificaOptanteSimplesNacional() {
      return new Promise(resolve => {
        this.servico.sep_data_tributacao = moment().format('YYYY-MM-DD');
        const nota_na_competencia = naCompetencia(this.servico.sep_data_tributacao, this.sep_competencia_data)
        if (this.substituicao || !nota_na_competencia) {
          this.servico.sep_data_tributacao = getFimMesDate(this.sep_competencia_data)
        }
        this.httpSend = true
        getNotaFiscalTributacaoSimples(this.empresa.eco_codigo, this.servico.sep_data_tributacao).then(result => {
          if (result.status) {
            resolve(result.dados);
          } else {
            resolve(false);
          }
        }).catch(error => {
          resolve(false);
          console.log(error)
        }).finally(() => {
          this.httpSend = false
        })
      })
    },
    listAllDescricaoFavoritas() {
      this.httpSendPesquisaCopyNota = true;
      listDescricaoFavorita({eco_codigo: this.empresa.eco_codigo}).then(response => {
        this.descricaoFavoritaDados.lista = response.dados;
      }).catch(error => {
        notifyErro("Erro Interno", error)
      }).finally(() => {
        this.httpSendPesquisaCopyNota = false
      })
    },
    saveDescricaoFavorito() {
      if (this.descricaoFavorito) {
        if (this.servico.sep_discriminacao && this.servico.sep_discriminacao.length > 1) {
          let dados = {
            eco_codigo: this.empresa.eco_codigo,
            dsf_descricao: this.servico.sep_discriminacao
          }
          this.httpSendSalvaFavorito = true;
          saveDescricaoFavorita(dados).then(response => {
            if (response.status) {
              this.descricaoFavoritaDados.dsf_codigo = response.dados;
              notifySucesso("DattaNFSe", response.mensagem)
            } else {
              this.descricaoFavorito = false;
              notifyErro("DattaNFSe", response.mensagem)
            }
          }).catch(error => {
            notifyErro("Erro Interno", error)
          }).finally(() => {
            this.httpSendSalvaFavorito = false
          })
        }
      } else {
        if (this.descricaoFavoritaDados.dsf_codigo) {
          this.deleteDescricaoFavorita(this.descricaoFavoritaDados.dsf_codigo)
        }
      }
    },
    deleteDescricaoFavorita(dsf_codigo) {
      this.httpSendSalvaFavorito = true;
      deleteDescricaoFavorita(this.empresa.eco_codigo, dsf_codigo).then(response => {
        if (response.status) {
          this.listAllDescricaoFavoritas();
          this.descricaoFavoritaDados.dsf_codigo = null;
          notifySucesso("DattaNFSe", response.mensagem)
        } else {
          notifyErro("DattaNFSe", response.mensagem)
        }
      }).catch(error => {
        notifyErro("Erro Interno", error)
      }).finally(() => {
        this.httpSendSalvaFavorito = false
      })
    },
    validaTabTomador() {
      this.$v.$touch();
      this.submitted = true;
      if (this.$v.tomador.$invalid && !this.isEstrangeiro) {
        return false;
      } else {
        if (!this.isEstrangeiro) {
          if (!validaCpfCnpj(this.tomador.sep_cpf_cnpj_tomador)) {
            this.cpfCnpjInvalid = true;
            notifyErro("Impossível emitir NFS-e", "Verifique o CPF ou CNPJ do tomador")
            return false;
          }
          if (this.empresa.pes_cpfcnpj === this.tomador.sep_cpf_cnpj_tomador) {
            this.tomadorIsPrestador = true;
            notifyErro("Impossível emitir NFS-e", "CPF ou CNPJ do tomador não pode ser idêntico ao do Prestador")
            return false;
          }
          if (!this.tomador.sep_municipio_tomador) {
            notifyErro("Impossível emitir NFS-e", "Verifique se o CEP foi digitado corretamente. Não utilize o autocompletar do navegador")
            return false;
          }
        } else {
          if (this.tomador.pas_codigo === '' || this.tomador.pas_codigo === null) {
            notifyErro("Impossível emitir NFS-e", "Verifique se o país foi selecionado corretamente")
            return false;
          }
          if (this.tomador.sep_razao_social_tomador === '') {
            this.pais_tomador.erro_razao_social = true;
            return false;
          }
          if (this.tomador.sep_endereco_tomador === '') {
            this.pais_tomador.erro_endereco = true;
            return false;
          }
        }
        window.scrollTo(0, 0);
        this.verificaRenetencao.rete = false;
        this.verificaRenetencao.ativo = false;
        if (!this.substituicao) {
          this.valores.sep_iss_retido = 'N';
          this.valores.sep_responsavel_retencao = null;
        }
        return true;
      }
    },
    async validaTabServico() {
      this.$v.$touch();
      if (this.servico.sep_tributacao_iss === '2' && this.isAvulso === false) {
        if (this.servico.ser_codigo) {
          if (this.servico.sep_municipio_incidencia.mun_codigo === this.entidade.mun_codigo) {
            notifyErro("Impossível emitir NFS-e", "Município de tributação deve ser diferente de " + this.entidade.mun_nome + '/' + this.entidade.mun_uf)
            return false;
          }
        }
      }
      if (this.$v.competencia.$invalid || this.$v.servico.$invalid) {
        return false;
      } else {

        const aux_tributacao = await this.verificaOptanteSimplesNacional();
        if (!aux_tributacao) {
          notifyErro("Impossível emitir NFS-e", "Não foi possível verificar a tributação da empresa. Entre em contato com o suporte da nota fiscal")
          return false;
        }

        const tributacao = parseInt(aux_tributacao.eco_tributacao);
        const temp_empresa = JSON.parse(JSON.stringify(this.empresa));
        temp_empresa.eco_tributacao = tributacao;
        await store.dispatch('auth/empresa', temp_empresa);

        //Reinicia os valores
        this.verificaAliquota = {
          isMei: false,
          isSimples: false,
          isDemaisEmpresas: false,
          desabilitaAliquota: false,
          aliquotaZerada: false,
        };

        if (tributacao === 1) {
          this.verificaAliquota.isMei = true;
          this.verificaAliquota.desabilitaAliquota = true;
        }
        if (tributacao === 2) {
          this.verificaAliquota.isSimples = true;
          this.verificaAliquota.desabilitaAliquota = false;
        }
        if (tributacao > 2) {
          this.verificaAliquota.isDemaisEmpresas = true;
          this.verificaAliquota.desabilitaAliquota = !(this.servico.ser_codigo.sre_retencao === 'S' && this.servico.sep_municipio_incidencia.mun_codigo !== this.entidade.mun_codigo);
        }

        if (tributacao === 1) {
          this.valores.sep_aliquota = 0.00;
          this.verificaAliquota.aliquotaZerada = true;
        } else {
          let aliquota = parseFloat((this.servico.ser_codigo && this.servico.ser_codigo.sre_aliquota) ? this.servico.ser_codigo.sre_aliquota : '0.00');
          this.valores.sep_aliquota = parseFloat(aliquota);
          if (aliquota < 0.01) {
            this.verificaAliquota.aliquotaZerada = true;
          }
        }

        if (this.servico.ser_codigo.sre_retencao === 'S' && (this.verificaAliquota.isDemaisEmpresas)) {
          if (this.tomador.eco_codigo) {
            if (this.servico.sep_municipio_incidencia.mun_codigo === this.entidade.mun_codigo) {
              this.verificaRenetencao.ativo = true;
            }
          }
        }

        if (this.servico.ser_codigo.sre_retencao === 'S' && (!this.verificaAliquota.isMei || !this.verificaAliquota.isSimples)) {
          if (this.servico.sep_municipio_incidencia.mun_codigo !== this.entidade.mun_codigo) {
            this.verificaRenetencao.ativo = true;
            this.verificaRenetencao.reter = false;
          }
        }

        //Se for substituto tributario sobrepoem as demais
        if (this.tomador.eco_substituicao === 'S' && this.verificaAliquota.isDemaisEmpresas) {
          this.verificaRenetencao.ativo = false;
          this.verificaRenetencao.reter = true;
        }

        if (this.tomador.eco_substituicao === 'S' && this.verificaAliquota.isSimples) {
          this.verificaRenetencao.ativo = true;
          this.verificaRenetencao.reter = false;
        }

        if (this.verificaRenetencao.reter) {
          this.valores.sep_iss_retido = 'S';
          this.valores.sep_responsavel_retencao = '1';
        }

        if (this.cnae_aux) {
          this.servico.cnae_codigo = this.cnae_aux;
        }

        if (this.isAvulso) {
          this.valores.sep_aliquota = parseFloat(this.servico.ser_codigo.sre_aliquota);
          this.verificaAliquota.desabilitaAliquota = true;
          this.verificaRenetencao.ativo = false;
          this.verificaRenetencao.reter = false;
          this.valores.sep_iss_retido = 'N';
        }
        if (this.isAvulso && this.isTomadorCNPJ) {
          this.baseMensal();
        }
        setTimeout(function () {
          window.scrollTo(0, 0)
        }.bind(this), 300)

        return true;
      }
    },
    validaTabValores() {
      this.valorLiquidoNegativo = false;
      this.valorISSNegativo = false;
      if (!this.verificaAliquota.aliquotaZerada) {
        this.$v.$touch();
        if (this.$v.valores.$invalid) {
          return false;
        }
        if (this.sep_iss < 0) {
          this.valorISSNegativo = true;
          return false
        }
      }
      if (this.valor_liquido < 0.01) {
        this.valorLiquidoNegativo = true;
        return false
      }
      if (this.verificaAliquota.isDemaisEmpresas && !this.verificaAliquota.aliquotaZerada) {
        if (this.valores.sep_aliquota < 0.01) {
          return false
        }
      }
      window.scrollTo(0, 0);
      return true;
    },
    confirmacao(nota_rascunho) {
      if (nota_rascunho === 1) {
        this.enviaNota(nota_rascunho);
      } else {
        let texto = "Confirma a emissão da nota fiscal?";
        if (this.substituicao) {
          texto = "Confirma a emissão da nota fiscal em substituição à nota fiscal n° " + this.substituindo.not_numero + " ?"
        }
        Swal.fire({
          title: texto,
          text: "",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#100e0e",
          confirmButtonText: "Sim",
          cancelButtonText: "Não"
        }).then(result => {
          if (result.isConfirmed) {
            this.enviaNota(nota_rascunho);
          } else {
            return nota_rascunho;
          }
        });
      }
    },
    confirmacaoAvulsa(nota_rascunho) {
      if (nota_rascunho === 1) {
        this.enviaNotaAvulsa(nota_rascunho);
      } else {
        Swal.fire({
          title: "Deseja emitir nota fiscal avulsa?",
          text: "A nota fiscal avulsa será emitida somente após o pagamento da taxa de emissão.",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#100e0e",
          confirmButtonText: "Sim",
          cancelButtonText: "Não"
        }).then(result => {
          if (result.isConfirmed) {
            this.enviaNotaAvulsa(nota_rascunho);
          } else {
            return nota_rascunho;
          }
        });
      }
    },
    enviaNota(nota_rascunho) {
      this.httpSend = true;
      const dados = {
        nota_rascunho: nota_rascunho,
        substituindo: this.substituindo,
        empresa: this.empresa,
        tomador: this.tomador,
        competencia: this.competencia,
        servico: this.servico,
        valores: this.valores,
      }
      dados.valores.sep_iss = arredondamento(dados.valores.sep_iss);
      gerarNota({dados}).then(response => {
        if (response.status) {
          notifySucesso("DattaNFSe", response.mensagem)
          this.visualiza_nota(response.dados);
          this.nota_envia_email(response.dados);
        } else {
          notifyErro("Erro ao emitir Nota Fiscal", response.mensagem)
        }
      }).catch(error => {
        notifyErro("Erro Interno", error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    enviaNotaAvulsa(nota_rascunho) {
      this.httpSend = true;
      const dados = {
        nota_rascunho: nota_rascunho,
        substituindo: this.substituindo,
        empresa: this.empresa,
        tomador: this.tomador,
        competencia: this.competencia,
        servico: this.servico,
        valores: this.valores
      }
      dados.valores.sep_iss = arredondamento(dados.valores.sep_iss);
      gerarNotaAvulsa({dados}).then(response => {
        if (response.status) {
          notifySucesso("DattaNFSe", response.mensagem)
          const dam = response.dados;
          if (dam.hasOwnProperty('not_hash')) {
            this.visualiza_nota(dam);
          } else {
            this.$router.push({name: 'contribuinte-financeiro-pagamento', params: {dam_hash: dam.dam_hash}})
          }
        } else {
          notifyErro("Erro Interno", response.mensagem)
        }
      }).catch(error => {
        notifyErro("Erro Interno", error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    nota_envia_email(nota) {
      getEnviaEmailNotaFiscal(nota.not_hash).then(result => {
        if (result.status) {
          notifySucesso("DattaNFSe", result.mensagem)
        } else {
          notifyErro("DattaNFSe", result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    visualiza_nota(nota) {
      this.$router.push({name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: nota.not_hash}})
    },
    resetaValores() {
      this.valores.sep_deducoes = 0;
    },
    populaNotaFiscal(dados) {
      this.tomador = {...dados.tomador}
      this.servico = {...dados.servico}
      this.servico.ser_codigo = this.list_atividades.find(x => x.ser_codigo === dados.servico.ser_codigo);
      if (this.servico.cnae_codigo) {
        this.cnae_aux = this.list_cnae.find(x => x.cnae_codigo === this.servico.cnae_codigo);
      } else {
        this.servico.cnae_codigo = "";
      }
      this.valores = {...dados.valores}
      if (this.servico.sep_tributacao_iss === '2' || this.servico.ser_codigo.sre_retencao === 'S') {
        this.verificaTributacao.disableForaMunicipio = false;
      }
      if (dados.tomador.pas_codigo) {
        this.tomador.pas_codigo = {
          pas_codigo: dados.tomador.pas_codigo,
          pas_nome: dados.tomador.pas_nome,
        }
        this.pais_tomador.pais = 'FORA';
      }
      if (this.substituicao) {
        this.substituindo.not_numero = dados.nota.not_numero;
        const competencia = String(dados.servico.sep_competencia);
        const competenciaArray = competencia.split('-');
        if (competenciaArray && competenciaArray.length > 0) {
          this.competencia.ano = competenciaArray[0];
          this.competencia.mes = competenciaArray[1];
          this.alter_ano();
        }
      }
    },
    selecionaUltimaNota(not_hash) {
      this.notaFiscal(not_hash);
    },
    selctAtividade(selectedOption) {
      this.resetaValores();
      this.municipioPadrao();
      let retencao = selectedOption.sre_retencao === 'S';
      let aliquota = parseFloat(selectedOption.sre_aliquota);

      this.verificaTributacao.disableForaMunicipio = !retencao;
      this.verificaTributacao.disableImune = true;
      this.verificaTributacao.disableTributacao = !retencao;
      this.servico.sep_exigibilidade_iss = '1';

      if (aliquota < 0.01) {
        this.verificaTributacao.disableImune = false;
        this.verificaTributacao.disableTributacao = true;
        this.servico.sep_exigibilidade_iss = '2';
      }

      if (this.isAvulso) {
        this.verificaTributacao.disableForaMunicipio = true;
        this.verificaTributacao.disableImune = true;
        this.verificaTributacao.disableTributacao = true;
        this.servico.sep_exigibilidade_iss = '2';
      }

      if (this.verificaTributacao.disableForaMunicipio) {
        this.servico.sep_tributacao_iss = '1';
      }

    },
    selctTributacao(selectedOption) {
      let tipoTributacao = parseInt(selectedOption);
      if (tipoTributacao !== 2) {
        this.municipioPadrao();
        this.municipios = [];
      }
    },
    alterRentencao(value) {
      if (value === 'S') {
        this.valores.sep_responsavel_retencao = '1';
      } else {
        this.valores.sep_responsavel_retencao = '0';
      }
    },
    municipioPadrao() {
      this.servico.sep_municipio_incidencia.mun_codigo = this.entidade.mun_codigo;
      this.servico.sep_municipio_incidencia.mun_nome = this.entidade.mun_nome;
      this.servico.sep_municipio_incidencia.mun_uf = this.entidade.mun_uf;
    },
    alter_ano() {
      if (this.competencia.ano.length !== 4) {
        return
      }
      this.meses = listMeses(this.competencia.ano);
      if (this.meses.length < 1) {
        this.competencia.mes = null;
      }
    },
    alter_pais() {
      if (this.pais_tomador.pais === 'BR') {
        this.tomador.pas_codigo = null;
        this.tomador.sep_cep_tomador = '';
        this.tomador.sep_inscricao_estadual_tomador = '';
        this.tomador.sep_inscricao_municipal_tomador = '';
        this.tomador.sep_cep_tomador = ''
        this.tomador.sep_nif_tomador = '';
        this.paises = [];
      }
    },
    openModalCopiar() {
      this.$refs['modal-copy-nota'].show();
    },
    closeModalCopiar() {
      this.$refs['modal-copy-nota'].hide();
    },
    openModalHistoricoDescricoes() {
      this.$refs['modal-historico-descricoes'].show();
      this.listAllDescricaoFavoritas();
    },
    closeModalHistoricoDescricoes() {
      this.$refs['modal-historico-descricoes'].hide();
    },
    selecionarDescricaoFavorito(descricao) {
      this.servico.sep_discriminacao = descricao;
      this.closeModalHistoricoDescricoes();
    },
    confirmacaoRemoverFavorito(dsf_codigo) {
      Swal.fire({
        title: "Confirmação",
        text: "Deseja realmente remover a descrição dos favoritos?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.isConfirmed) {
          this.deleteDescricaoFavorita(dsf_codigo)
        }
      });
    },
    isLastStep() {
      if (this.$refs.tabNota) {
        return this.$refs.tabNota.isLastStep
      }
      return false
    },
    labelPais({pas_codigo, pas_nome}) {
      return `${pas_codigo} - ${pas_nome}`
    },
    labelMunicipio({mun_nome, mun_uf}) {
      return `${mun_nome} - ${mun_uf}`
    },
    customLabelAtividade({ser_codigo, ser_descricao}) {
      return `${ser_codigo} – ${ser_descricao}`
    },
    customLabelCnae({cnae_codigo, cnae_nome}) {
      return `${cnae_codigo} – ${cnae_nome}`
    }
  }
};
</script>
